module.exports = __webpack_public_path__ + "img/watermelon-food.a3cda8a3.svg";